<template>
  <v-card>
    <v-card-title>
      {{ this.title }}
      <v-btn v-if="editable" depressed @click="editRow()">
        <v-icon right>edit</v-icon>
        <span>Edit</span>
      </v-btn>
      <v-btn
        v-if="editing"
        depressed
        @click="formatForBulk(data, headers, items)"
      >
        <v-icon right>save</v-icon>
        <span>Save</span>
      </v-btn>
      <v-btn v-if="editable" depressed @click="refresh()">
        <v-icon right>refresh</v-icon>
        <span>Refresh</span>
      </v-btn>
      <v-btn depressed @click="nextPage(pageNo)">
        <v-icon right>refresh</v-icon>
        <span>Next page</span>
      </v-btn>
      <v-btn v-if="pageNo > 1" depressed @click="backPage(pageNo)">
        <v-icon right>refresh</v-icon>
        <span>Back 1 Page</span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="items" :search="search">
      <template slot="items" slot-scope="props">
        <tr @click="clickTableRow(props.item)">
          <td v-for="(field, index) in headers" :key="index">
            {{ genFieldItem(props.item, field) }}
            <div v-if="editing">
              <input
                v-model="data[getIndex(props.item.id, index, headers)]"
                :placeholder="`Edit me`"
              />
            </div>
          </td>
        </tr>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for <strong>"{{ search }}"</strong> found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex'
export default {
  name: 'GenericListTable',
  props: {
    parentID: {
      type: Number,
      default: null
    },
    title: {
      type: String
    },
    headers: {
      type: Array,
      default: null
    },
    url: {
      type: String
    },
    apiResponseField: {
      type: String
    },
    apiQueryParams: {
      type: String,
      default: null
    },
    onClickRoute: {
      type: String
    },
    onClickParams: {
      type: Function,
      default: null
    },
    onClickQuery: {
      type: Function,
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    },
    saveUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      search: '',
      items: [],
      editing: false,
      data: {},
      pageNo: 1
    }
  },
  async beforeMount () {
    const urlParams = {}
    if (this.parentID && this.parentID >= 0) {
      urlParams.parentid = this.parentID
    }
    try {
      var urlWithParams = this.url
      if (this.apiQueryParams != null) {
        urlWithParams = urlWithParams.concat(this.apiQueryParams)
      }
      const response = await this.$http.get(urlWithParams, {
        params: urlParams
      })
      this.items = response.data[this.apiResponseField]
    } catch {
      this.failedGroupList()
    }
  },
  methods: {
    /**
     * Converts the
     */
    genFieldItem (item, field) {
      const fieldValues = field.value.split('.')
      if (fieldValues.length === 1) {
        return item[fieldValues[0]]
      } else if (fieldValues.length === 2) {
        // Gets nested values in the returned json data
        return item[fieldValues[0]][fieldValues[1]]
      }
    },
    /**
     * Refreshs the data displayed in the listTable
     */
    async refresh () {
      const urlParams = {}
      this.data = {}

      if (this.parentID && this.parentID >= 0) {
        urlParams.parentid = this.parentID
      }
      try {
        var urlWithParams = this.url
        if (this.apiQueryParams != null) {
          urlWithParams = urlWithParams.concat(this.apiQueryParams)
        }
        if (this.pageNo > 1) {
          urlWithParams = urlWithParams.concat('?page=')
          urlWithParams = urlWithParams.concat(this.pageNo.toString())
        }

        const response = await this.$http.get(urlWithParams, {
          params: urlParams
        })

        this.items = response.data[this.apiResponseField]
      } catch {
        this.failedGroupList()
      }
      // vm.$forceUpdate();
    },
    failedGroupList () {
      this.$emit(
        'error',
        `Failed to retrieve a list of ${this.title.toLowerCase()}.`
      )
    },
    getIndex (rowIndex, collumnIndex, headers) {
      var id = rowIndex.toString()
      var field = headers[collumnIndex].value

      return id + '%' + field
    },
    clickTableRow (item) {
      if (!this.editing) {
        const params = this.onClickParams ? this.onClickParams(item) : {}
        const query = this.onClickQuery ? this.onClickQuery(item) : {}
        this.$router.push({
          name: this.onClickRoute,
          params: params,
          query: query
        })
      }
    },
    editRow () {
      this.editing = true
    },
    /**
     * saves the data entered into the editboxes.
     *
     * Params:
     * Data - dictionary contaning the edited values
     * Headers - list of data headers
     * items - list of 'original' items
     */
    async formatForBulk (data, headers, items) {
      // Filters unique values
      function onlyUnique (value, index, self) {
        return self.indexOf(value) === index
      }

      var ids = []
      // Get the ids from dictionary key
      for (let k in data) {
        var id = k.split('%')[0]
        ids.push(parseInt(id))
      }
      // Get unique ids only
      var uIds = ids.filter(onlyUnique)

      var modelRecords = []
      var max = Math.max.apply(Math, uIds)
      var revisedIds = []
      // Make a list of dictionarys containing ingore for every value
      for (var i = 0; i < max; i++) {
        var modelRecord = {}
        revisedIds.push(i + 1)
        for (var k = 1; k < headers.length; k++) {
          modelRecord[headers[k].value] = 'ignore'
        }

        modelRecords.push(modelRecord)
      }
      // Replace the values in the model dictionary with edited values
      for (let k in data) {
        var id1 = k.split('%')[0]
        var fieldName = k.split('%')[1]
        var newValue = data[k]

        modelRecords[id1 - 1][fieldName] = newValue
      }

      var records = []
      for (var j = 0; j < modelRecords.length; j++) {
        // checks records follow database conventions
        var newRec = this.validateRecord(modelRecords[j])

        records.push(newRec)
      }

      // function used to check for empty records
      function checkIgnore (rec) {
        return rec === 'ignore'
      }

      this.editing = false
      var editedRecords = []
      var changedIds = []

      // Filter out any dictionarys containing only ignore, and also remove their ids
      for (var h = 0; h < records.length; h++) {
        var values = Object.values(records[h])

        if (!(values.every(checkIgnore))) {
          editedRecords.push(records[h])
          changedIds.push(revisedIds[h])
        }
      }
      var body = {}
      if (this.title === 'Physical Info') {
        body['physicalInfoRecords'] = editedRecords
      }
      if (this.title === 'Assets') {
        body['assetinfo_arr'] = editedRecords
      }
      if (this.title === 'Groups') {
        body['groupinfolist'] = editedRecords
      }
      // Send the data request
      var urlWParams = this.saveUrl + `[${changedIds}]`
      const response = await this.$http.post(urlWParams, body)

      this.data = {}
      window.alert(response.data.message)
    },
    validateRecord (record) {
      for (let k in record) {
        if (record[k] === undefined || record[k] === null || record[k] === '') {
          record[k] = 'ignore'
        }
        if (k === 'assetstate') {
          if (record[k] !== 'Free' && record[k] !== 'Reserved' && record[k] !== 'Blocking' && record[k] !== 'Installed') {
            record[k] = 'ignore'
          }
        }
        if (k === 'co_groupcode') {
          if (!(record[k].includes('_'))) {
            record[k] = 'ignore'
          }
          if (this.title === 'Groups') {
            record[k] = 'ignore'
          }
        }
        if (k === 'physicaltype') {
          var allowedTypes = ['Arad', 'Elster']
          if (!allowedTypes.includes(record[k])) {
            record[k] = 'ignore'
          }
        }
      }

      return record
    },
    nextPage (currentPage) {
      this.pageNo = currentPage + 1

      this.$nextTick(function () {
      })
      this.refresh()
    },
    backPage (currentPage) {
      this.pageNo = currentPage - 1

      this.$nextTick(function () {
      })
      this.refresh()
    }
  }
}
</script>
